import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=ea138036"
import script from "./breadcrumb.ts?vue&type=script&lang=js&external"
export * from "./breadcrumb.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports